const actionTypes = require('constants/actionTypes');
const Immutable = require('immutable');

const setInitialState = () => {
    return Immutable.Map().merge({
        showMap: false,
        branches: [],
    });
};

const initialState = setInitialState();

const optionsReducer = (state, action) => {
    state = state || initialState;

    let branches;
    switch (action.type) {
        case actionTypes.SHOW_MAP:
            return state.merge({
                showMap: true,
            });

        case actionTypes.HIDE_MAP:
            return state.merge({
                showMap: false,
            });

        case actionTypes.ADD_BRANCHES:
            branches = state.get('branches');
            action.data.branches.map(branch => {
                branches = branches.push(
                    Immutable.Map({
                        unidad: branch.unidad,
                        nombre: branch.nombre,
                        ind_ambitoCodigo: branch.ind_ambitoCodigo,
                        direccion: branch.direccion,
                        cp: branch.cp,
                        codLocalidad: branch.codLocalidad,
                        descLocalidad: branch.descLocalidad,
                        coorXETRS89: branch.coorXETRS89,
                        coorYETRS89: branch.coorYETRS89,
                        coorXWGS84: branch.coorXWGS84,
                        coorYWGS84: branch.coorYWGS84,
                        telefono: branch.telefono,
                        horarioLV: branch.horarioLV,
                        horarioS: branch.horarioS,
                        horarioF: branch.horarioF,
                        latitudETRS89: branch.latitudETRS89,
                        longitudETRS89: branch.longitudETRS89,
                        latitudWGS84: branch.latitudWGS84,
                        longitudWGS84: branch.longitudWGS84,
                    })
                );
            });

            return state.merge({
                branches,
            });

        case actionTypes.CLEAR_BRANCHES:
            branches = [];

            return state.merge({
                branches,
            });

        default:
            return state;
    }
};

module.exports = optionsReducer;
